import loadable from '@loadable/component';
import Loading from '../../../components/Loader';
import { fetchArticle } from '../../../actions/articles';
import { fetchLatestArticles } from '../../../actions/latest-articles';
import { fetchStates } from '../../../actions/states';
import { fetchModalQuestions } from '../../../actions/questions';
import { State } from '../../../reducers';
import { getCatgoryByArticleKey } from '../../../selectors';
import { fetchCategoryFromKey } from '../../../actions/category';

const Article = loadable(() => import(/* webpackChunkName: "article" */ './Container'), {
  fallback: Loading
});

Article.needs = async (props, { dispatch, getState }) => {
  const article = await dispatch(fetchArticle(props.params.key));
  const latesArticle = dispatch(fetchLatestArticles());
  const states = dispatch(fetchStates());
  const state: State = getState();
  const category = await getCatgoryByArticleKey(state, props.params.key);
  const modalQuestions = dispatch(fetchModalQuestions(category.key));
  const categoryObject = dispatch(fetchCategoryFromKey(category.key));

  return Promise.all([article, latesArticle, states, modalQuestions, category, categoryObject]);
};

export default Article;
